/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Footer_Link_DirectoriesInputs */

const en_directory_footer_link_directories = /** @type {(inputs: Directory_Footer_Link_DirectoriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Directory Catalog`)
};

const zh_directory_footer_link_directories = /** @type {(inputs: Directory_Footer_Link_DirectoriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目录大全`)
};

/**
* | output |
* | --- |
* | "Directory Catalog" |
*
* @param {Directory_Footer_Link_DirectoriesInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_footer_link_directories = /** @type {((inputs?: Directory_Footer_Link_DirectoriesInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Footer_Link_DirectoriesInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_footer_link_directories(inputs)
	return zh_directory_footer_link_directories(inputs)
});
export { directory_footer_link_directories as "directory.footer.link_directories" }